/* eslint-disable @typescript-eslint/no-namespace */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContainerDTO } from '../models/containerDto';

export namespace ToolTrackerState {
  export interface IState {
    // Container selection + cache
    loadedContainers: { [key: string]: ContainerDTO };
    containerCount: number;
    selectedContainerId?: string;
  }

  export const initialState: IState = {
    loadedContainers: {},
    containerCount: 0,
  };

  const selectFeature = createFeatureSelector<IState>('tool-tracker');

  // Container selection + cache
  export const selectSelectedContainer = createSelector(
    selectFeature,
    (x) => x.loadedContainers[x.selectedContainerId]
  );
  export const selectContainerId = (id: string) =>
    createSelector(selectFeature, (x) => x.loadedContainers[id]);
  export const selectContainerDict = createSelector(
    selectFeature,
    (x) => x.loadedContainers
  );
  export const selectContainer = createSelector(selectContainerDict, (x) =>
    Object.values(x)
  );
}
